/**
 * Basis-Evaluierungs-Service für automatische Feldberechnungen
 * Die App erweitert diese Klasse und registriert konkrete Evaluatoren.
 */

import { Injectable } from '@angular/core';
import { IEvaluationService } from '../../core/interfaces';
import { EvaluatorFunction } from '../../core/types';
import { kd } from '../../core/utils';

@Injectable()
export abstract class BaseEvaluationService implements IEvaluationService {
	protected evaluators_ = new Map<string, EvaluatorFunction>();
	protected context: unknown;

	/**
	 * Setzt den Kontext für die Evaluierung (z.B. das aktuelle Dokument)
	 */
	setContext(ctx: unknown): void {
		this.context = ctx;
	}

	/**
	 * Registriert einen Evaluator für einen Feldnamen
	 */
	registerEvaluator(key: string, func: EvaluatorFunction): void {
		this.evaluators_.set(key, func);
	}

	/**
	 * Prüft ob für den Feldnamen ein Evaluator registriert ist
	 */
	has(key: string): boolean {
		const k = kd(key).key;
		return this.evaluators_.has(k);
	}

	/**
	 * Führt die Evaluierung für das Feld durch
	 */
	evaluate(key: string): string | number | undefined {
		const d = kd(key);
		if (!this.evaluators_.has(d.key)) {
			console.warn(`BaseEvaluationService: Unknown evaluator "${d.key}"`);
			return undefined;
		}
		const func = this.evaluators_.get(d.key)!;
		return func(this.context, d.index, d.key);
	}
}
